/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * transition (interpolation) between values
 */
export class Target {
    constructor(name, type, source, target) {
        this._name = name;
        this._type = type;
        this._source = this._clone(source);
        if (Array.isArray(target)) {
            this._target = this._clone(source);
            this._fromArrayToTarget(target);
        }
        else {
            this._target = this._clone(target);
        }
    }
    // tslint:disable-next-line:no-any
    interpolate(obj, t) {
        switch (this._type.toLowerCase()) {
            case 'vector':
            case 'vector2':
            case 'vector3':
            case 'vector4':
                obj[this._name].lerpVectors(this._source, this._target, t);
                break;
            case 'color':
                obj[this._name].copy(this._source).lerp(this._target, t);
                break;
            case 'quaternion':
                obj[this._name].copy(this._source).slerp(this._target, t);
                break;
            case 'scalar':
            case 'double':
            case 'float':
            case 'number':
            case 'integer':
                obj[this._name] = this._source + t * (this._target - this._source);
                break;
            default:
                obj[this._name] = (t >= 0.5) ? this._source : this._target;
        }
    }
    // tslint:disable-next-line:no-any
    _clone(val) {
        switch (this._type.toLowerCase()) {
            case 'vector':
            case 'vector2':
            case 'vector3':
            case 'vector4':
            case 'color':
            case 'quaternion':
                return val.clone();
            default:
                return val;
        }
    }
    _fromArrayToTarget(val) {
        switch (this._type.toLowerCase()) {
            case 'vector':
            case 'vector2':
            case 'vector3':
            case 'vector4':
            case 'color':
            case 'quaternion':
                this._target.fromArray(val);
                break;
            default:
                this._target = val;
        }
    }
}
//# sourceMappingURL=Target.js.map